import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TShopifySalesChannel } from 'redux/reducers/shopifyStores/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { EDIT_SALES_CHANNEL_ACTION, DELETE_SALES_CHANNEL_ACTION } from './constants';

export const tableStructure: TTableStructure<keyof TShopifySalesChannel>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'App ID',
		selector: 'app_id',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Title',
		selector: 'title',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Shop URL',
		selector: 'shop_url',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Comment',
		selector: 'comment',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'New',
		selector: 'is_new',
		show: true,
		sortable: false,
		filterable: true,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Active',
		selector: 'is_active',
		show: true,
		sortable: false,
		filterable: true,
		filter: [
			['true', 'Active'],
			['false', 'Inactive'],
		],
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Created At',
		selector: 'created_at',
		show: true,
		sortable: false,
		filterable: false,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated At',
		selector: 'updated_at',
		show: true,
		sortable: false,
		filterable: false,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: EDIT_SALES_CHANNEL_ACTION,
				icon: EIconButtons.EDIT,
			},
			{
				name: DELETE_SALES_CHANNEL_ACTION,
				icon: EIconButtons.DELETE,
				color: 'error.main',
			},
		],
	},
];
